import CustomerInvoicesTableActions from '@/components/customer-dashboard/CustomerInvoicesTableActions.vue';
import DataTableColumnHeader from '@/components/datatable/DataTableColumnHeader.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import type { Invoice } from '@/types';
import { formatCurrency, formatDate } from '@/utils/helpers';
import type { ColumnDef } from '@tanstack/vue-table';
import { h } from 'vue';

export const columns: ColumnDef<Invoice>[] = [
    {
        accessorKey: 'booked_invoice_number',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'dashboards.invoices.table.number',
            }),
    },
    {
        accessorKey: 'date',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'dashboards.invoices.table.date',
            }),
        cell: ({ row }) => {
            return formatDate(row.original.date);
        },
    },
    {
        accessorKey: 'net_amount',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'dashboards.invoices.table.amount',
            }),
        cell: ({ row }) => {
            return formatCurrency(row.original.net_amount);
        },
    },
    {
        accessorKey: 'status',
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'dashboards.invoices.table.status',
            }),
        cell: ({ row }) => {
            return h(StatusIndicator, {
                active: row.original.status,
                type: 'invoiceStatus',
            });
        },
    },
    {
        id: 'actions',
        enableHiding: false,
        header: ({ column }) =>
            h(DataTableColumnHeader, {
                column: column,
                title: 'tables.actions',
            }),
        cell: ({ row }) => {
            return h(CustomerInvoicesTableActions, {
                invoice: row.original,
            });
        },
    },
];
